import MaskedLines from "@/components/motion/MaskedLines";
import { motion } from "framer-motion";

export default function Closing({ onBuy }) {
  return (
    <section className="bg-[#2E9EF0] overflow-hidden">
      <div className="max-w-6xl mx-auto px-5 py-24 md:py-32">
        <MaskedLines
          lines={["Siempre cerca,", "aunque no estés."]}
          className="text-[#12263A] font-black leading-[1.0] text-4xl sm:text-5xl lg:text-[72px] max-w-4xl"
          style={{ letterSpacing: "-0.02em" }}
        />
        <motion.p
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-6 text-[17px] leading-[1.6] text-[#12263A] max-w-md"
        >
          Dale a tu hijo la libertad de explorar. Quédate con la tranquilidad de siempre saber.
        </motion.p>
        <motion.button
          initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.42 }}
          onClick={onBuy}
          data-testid="closing-buy-btn"
          className="mt-8 px-8 py-4 rounded-[20px] bg-[#12263A] text-white border-2 border-[#12263A] font-bold hover:bg-transparent hover:text-[#12263A] transition-colors active:translate-y-0.5"
        >
          Comprar mi Kiddio
        </motion.button>
      </div>
    </section>
  );
}
